var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "markdown-quick-reference uk-margin"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showModal($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('showHelp')))]), _vm._v(" "), _c('modal', {
    ref: "modal",
    staticClass: "uk-modal-container",
    attrs: {
      "title": "Markdown-Formatierung",
      "auto-overflow": ""
    }
  }, [_c('h3', [_vm._v("Überschriften")]), _vm._v(" "), _c('div', {
    staticClass: "uk-grid-small uk-grid-match",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', {
    staticClass: "uk-width-1-2"
  }, [_c('pre', [_vm._v("# Überschrift 1\n## Überschrift 2\n### Überschrift 3")])]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-2"
  }, [_c('pre', [_vm._v("<h1>Überschrift 1</h1>\n<h2>Überschrift 2</h2>\n<h3>Überschrift 2</h3>")])])]), _vm._v(" "), _c('h3', [_vm._v("Text-Formatierung")]), _vm._v(" "), _c('div', {
    staticClass: "uk-grid-small uk-grid-match",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', {
    staticClass: "uk-width-1-2"
  }, [_c('pre', [_vm._v("**strong**\n*italic*\n_underlined_")])]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-2"
  }, [_c('pre', [_vm._v("<strong>strong</strong>\n<em>italic</em>\n<u>underlined</u>")])])]), _vm._v(" "), _c('h3', [_vm._v("Links")]), _vm._v(" "), _c('div', {
    staticClass: "uk-grid-small uk-grid-match",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', {
    staticClass: "uk-width-1-2"
  }, [_c('pre', [_vm._v("[link](http://www.example.com)")])]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-2"
  }, [_c('pre', [_vm._v("<a href=\"http://www.example.com\">link</a>")])])]), _vm._v(" "), _c('h3', [_vm._v("Listen")]), _vm._v(" "), _c('div', {
    staticClass: "uk-grid-small uk-grid-match",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', {
    staticClass: "uk-width-1-1"
  }, [_c('h4', [_vm._v("Unsortierte Liste")])]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-2"
  }, [_c('pre', [_vm._v("* List Item 1\n* List Item 2\n* List Item 3")])]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-2"
  }, [_c('pre', [_vm._v("<ul>\n  <li>List Item 1</li>\n  <li>List Item 2</li>\n  <li>List Item 3</li>\n</ul>")])]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-1"
  }, [_c('h4', [_vm._v("Sortierte Liste")])]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-2"
  }, [_c('pre', [_vm._v("1. List Item 1\n2. List Item 2\n3. List Item 3")])]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-2"
  }, [_c('pre', [_vm._v("<ol>\n  <li>List Item 1</li>\n  <li>List Item 2</li>\n  <li>List Item 3</li>\n</ol>")])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51917ee8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/MarkdownQuickReference.vue
// module id = 1984
// module chunks = 0